import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { WARN, DANGER } from 'conversations-message-history/common-message-format/constants/emailAuthenticationStatusTypes';
// @ts-expect-error module not typed
import { provideThreadView } from '../../thread-view/decorators/provideThreadView';
import { getOriginalGenericChannelId, getIsFiltered } from 'conversations-thread-data/thread-details/public/operators';
import { useThreadDetails } from '../../thread-details-feature/public/hooks/useThreadDetails';
// @ts-expect-error module not typed
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getUpdatedConversation } from '../../usage-tracking/utils/threadInteraction';
import { getEmailAndAuthenticationStatus } from '../selectors/getEmailAndAuthenticationStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIAlert = styled(UIAlert).withConfig({
  displayName: "ConnectedMessageAuthenticityAlert__StyledUIAlert",
  componentId: "xdlo1w-0"
})(["min-height:auto !important;"]);
const ButtonWrapper = styled.div.withConfig({
  displayName: "ConnectedMessageAuthenticityAlert__ButtonWrapper",
  componentId: "xdlo1w-1"
})(["margin:10px 0;"]);
const ConnectedMessageAuthenticityAlert = ({
  threadId
}) => {
  const {
    asyncThreadDetails,
    markAsSpam
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  const genericChannelId = getOriginalGenericChannelId(threadDetails);
  const {
    email,
    authenticationStatus
  } = useSelector(getEmailAndAuthenticationStatus);

  /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  if (!threadDetails || getIsFiltered(threadDetails)) {
    return null;
  }
  const handleMarkAsSpam = () => {
    markAsSpam();
    trackEvent( /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
    getUpdatedConversation({
      updateType: 'mark spam',
      genericChannelId
    }));
  };
  if (typeof authenticationStatus !== 'string') {
    return null;
  }
  return [WARN, DANGER].includes(authenticationStatus) ? /*#__PURE__*/_jsxs(StyledUIAlert, {
    use: "inline",
    type: "danger",
    closeable: false,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.title"
    }),
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.description",
      options: {
        email
      }
    }), /*#__PURE__*/_jsx(ButtonWrapper, {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        size: "extra-small",
        onClick: handleMarkAsSpam,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.alerts.EMAIL_AUTHENTICATION_STATUS.danger.button"
        })
      })
    })]
  }) : null;
};
ConnectedMessageAuthenticityAlert.displayName = 'ConnectedMessageAuthenticityAlert';
export default provideThreadView(ConnectedMessageAuthenticityAlert);